import _ from "lodash";

export type TLoginForm = {
  username: string;
  password: string;
};

export type TImageSignatures = {
  Policy: string;
  Signature: string;
  "Key-Pair-Id": string;
};

export type TTokens = {
  access: string;
};

export type TLink = {
  text: string;
  url: string;
};

// map to TProgram
export type ILoginProgram = {
  programName: string;
  programLink: TLink;
  iconUrl: TLink;
  brandLists: Array<TBrandItem>;
};

// map to extras in TProgram
export type TBrandItem = {
  brandName: string;
  brandUrl: string;
  brandImage: {text: string, url: string};
};

export type TProgramsResponse = {
  title: string;
  loginPrograms: Array<ILoginProgram>;
  brandLists: Array<TBrandItem>;
};

export type TProgramsResponses = Array<TProgramsResponse>;

export type TProgram = {
  iconUrl: string;
  programName: string;
  link: string;
  brands?: Array<any> | null;
};

export type TSection = {
  title: string;
  programs: Array<TProgram>;
};

export type TPrograms = {
  pageLogoUrl: string;
  sections: Array<TSection>;
};

export type TImageCloudSignatures = {
  "CloudFront-Policy": string;
  "CloudFront-Signature": string;
  "CloudFront-Key-Pair-Id": string;
};

export const mapProgramFields = (data: TProgramsResponses) => {
  const programs: TPrograms = {
    pageLogoUrl: "/rapid-tph-logo.png",
    sections: [],
  };

  const sections: any = data.map((d) => {
    const _program = d.loginPrograms.map((lp, i) => {
      const _lp: TProgram = {
        iconUrl: lp.iconUrl.url,
        link: lp.programLink.url,
        programName: lp.programName,
        brands: lp.brandLists.length > 0 ? lp.brandLists.map(b => b.brandImage.url) : null
      };

      return _lp;
    });

    return { title: d.title, programs: _program };
  });

  programs.sections = sections;

  return programs;
};

export const mapImageSignatureFields = (data: TImageCloudSignatures) => {
  const signatures: TImageSignatures = {
    Policy: data["CloudFront-Policy"],
    Signature: data["CloudFront-Signature"],
    "Key-Pair-Id": data["CloudFront-Key-Pair-Id"],
  };

  return signatures;
};
